import React from "react";
import { useState, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';

import SearchBar from "./common/SearchBar";

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';



export default function FormEditParams({formData, setFormData}){

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();

  const [formErrors, setFormErrors] = useState({})

  
  const handleChange = (event) => {
    let newFormData = structuredClone(formData);
    
    // Обработка изменений в полях samples_numbers_and_literals
    if (event.target.id.startsWith('sample_')) {
      const index = parseInt(event.target.id.split('_')[1]);
      if (!newFormData.samples_numbers_and_literals) {
        newFormData.samples_numbers_and_literals = [];
      }
      if (!newFormData.samples_numbers_and_literals[index]) {
        newFormData.samples_numbers_and_literals[index] = ['', ''];
      }
      newFormData.samples_numbers_and_literals[index][0] = event.target.value;
    } else if (event.target.id.startsWith('literal_')) {
      const index = parseInt(event.target.id.split('_')[1]);
      if (!newFormData.samples_numbers_and_literals) {
        newFormData.samples_numbers_and_literals = [];
      }
      if (!newFormData.samples_numbers_and_literals[index]) {
        newFormData.samples_numbers_and_literals[index] = ['', ''];
      }
      newFormData.samples_numbers_and_literals[index][1] = event.target.value;
    } else {
      // Обычные поля формы
      newFormData[event.target.id] = event.target.value;
    }

    setFormData(newFormData)
  };

  const handleAddItem = () => {
    let newFormData = structuredClone(formData);
    if (!newFormData.samples_numbers_and_literals) {
      newFormData.samples_numbers_and_literals = [];
    }
    newFormData.samples_numbers_and_literals.push(['Образец' + (newFormData.samples_numbers_and_literals.length + 1), '']);
    setFormData(newFormData);
  };

  const handleRemoveItem = (index) => {
    let newFormData = structuredClone(formData);
    if (newFormData.samples_numbers_and_literals && newFormData.samples_numbers_and_literals.length > index) {
      newFormData.samples_numbers_and_literals.splice(index, 1);
      setFormData(newFormData);
    }
  }
  

  function saveForm () {

    //alert('!!!')

    let params = {
      section: formData.section || "",
      samples_numbers_and_literals: formData.samples_numbers_and_literals || [],
      form_view_mode: formData.form_view_mode,
    };

    //console.log(params)

    axios_api.put(api_url + `/manage_form/` + formData.id, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        console.log("Form params saved");
        navigate(0)
        //setIsDirty(false);
        // Очищаем ошибки валидации после успешного сохранения
        //setValidationErrors({
        //  schema: { errors: [], warnings: [] },
        //  uiSchema: { errors: [], warnings: [] }
        //});
        //setHasValidationErrors(false);
      },
      (error) => {
        console.log(error);
        setFormErrors(error.response?.data)
      }
    );
  }
  



  // Получаем массив образцов и литералов (или пустой массив по умолчанию)
  const samplesAndLiterals = formData.samples_numbers_and_literals || [];

  let rows = []
  for (let i = 0; i < samplesAndLiterals.length; i++) {
    const item = samplesAndLiterals[i] || ['', ''];
    rows.push(
      <div 
        className="row mb-3" 
        key={i}
      >
        <div className="col-sm-4">
          <label className="form-text">oбразец</label>
          <input
            id={`sample_${i}`}
            type="text"
            className="form-control"
            value={item[0] || ''}
            onChange={handleChange}
            readOnly
          />
        </div>
        <div className="col-sm-4">
          <label className="form-text">литерал</label>
          <input
            id={`literal_${i}`}
            type="text"
            className="form-control"
            value={item[1] || ''}
            onChange={handleChange}
          />
        </div>        
        <div className="col-sm-2 d-flex align-items-end">
          <button 
            type="button"
            className="btn editor-button mx-0 my-1 py-1" 
            onClick={(e) => {
              e.preventDefault();
              handleRemoveItem(i);
            }}
            title="Удалить элемент"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="bi bi-x-square" viewBox="0 0 17 17">
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
            </svg>
          </button>
        </div>  
      </div>  
    )
  }

  console.log(formErrors)

  return (
    <>
      <div className="row">
        <h3 className="m-3">Параметры формы   <span className="ms-2">{formData.form_code}</span></h3>
      </div>
      <div className='m-3'>
        <div className="lk-form">
          <form>
            <div className="input-group mt-3 mb-2">
              <label className="">
                <p>Введите значение section</p> 
                <input id="section" type="text" className="form-control"  value={formData['section'] ? formData['section'] : ""} onChange={handleChange}></input>
              </label>
            </div>
            { formErrors?.section &&
              <p className="text-danger">{formErrors["section"]}</p>
            }
            <div className="input-group mt-5 mb-2">
              <label className="">
                <p>Образцы и литералы</p> 
                {rows}
                <button 
                  className="btn editor-button ms-0 mt-2" 
                  onClick={(e) => {e.preventDefault(); handleAddItem();}}
                  title="Добавить элемент"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-plus-square" viewBox="0 0 17 17">
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                  </svg>
                </button>

              </label>
            </div>
            { formErrors?.samples_numbers_and_literals &&
              <p className="text-danger">{JSON.stringify(formErrors["samples_numbers_and_literals"])}</p>
            }
            <div className="input-group mt-5 mb-2">
              <label className="">
                <p>Режим отображения формы</p> 
                <select id="form_view_mode" type="select" className="lk-select form-select"  value={formData['form_view_mode'] ? formData['form_view_mode'] : ""} onChange={handleChange}>
                  <option value="SCREEN_FIT">Вписывать в экран по ширине</option>
                  <option value="HORIZONTAL_SCROLL">Горизонтальная прокрутка при ширине больше экрана</option>
                </select>
              </label>
            </div>
            { formErrors?.section &&
              <p className="text-danger">{formErrors["form_veiw_mode"]}</p>
            }            
            <button type="button" onClick={saveForm} className="btn lk-button my-3">Сохранить параметры</button>
          </form>
        </div>               
      </div> 
    </>
  )
}